/**
 * Fakten und Hilfeangebote als Konstanten - Texte über i18n, kein CMS.
 *
 * Die Adressen stehen hier und nicht in den Übersetzungen, weil sie keine
 * Sprache haben: ein Telefonlink bleibt derselbe, egal in welcher Sprache
 * daneben steht.
 */
// "chase" (Verluste zurueckholen) ist auf Wunsch der Landesfachstelle entfallen
// (WETTBANDIT-79).
export const FACT_KEYS = ['tax', 'margin', 'knowledge'] as const

export interface HelpLink {
    key: 'lots' | 'ausgezockt' | 'hotline'
    href: string
}

// Angaben nach der Rueckmeldung der Landesfachstelle (WETTBANDIT-78): lots-nrw.de
// antwortet nicht mehr, und statt des bundesweiten BZgA-Telefons soll die Infoline
// Gluecksspielsucht NRW dastehen - GLUEXXIT ist ein Angebot fuer NRW.
export const HELP_LINKS: HelpLink[] = [
    { key: 'lots', href: 'https://gluecksspielsucht-nrw.de' },
    { key: 'ausgezockt', href: 'https://www.ausgezockt.de' },
    { key: 'hotline', href: 'tel:+498000776611' },
]
